var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 10.833a4.167 4.167 0 1 1-.002 8.334 4.167 4.167 0 0 1 .002-8.334m2.499-1.104A5.833 5.833 0 0 0 8.894 17.5H3.332V5.833L6.665 2.5h10zm-3.333 5.616 1.494 1.494 1.179-1.179-1.006-1.006v-1.738h-1.667z"
  })));
};
export default SvgHistory;